angular.module('app.controllers.non-paginated-forms.esap-spanish', [])
    .controller("EsapControllerSpanish", function ($scope, $window, $http, appConstants) {
        $scope.aversion = appConstants.version;
	$scope.isOutSideOfCalifornia=false;
        $scope.caprequired = appConstants.captchaRequired; // localhost = false otherwise true
        $scope.form_processed = "";
        $scope.account="";
        $scope.form_name = "Programa de Asistencia de Abhorro de Energ\u00cda";
        $scope.allowedChars = /^[A-z0-9-'.,\!\+\(\)\/ ]+$/;
        $scope.allowedCharsSpanish=/^[A-z0-9\u00E0-\u00FC\u00C0-\u00DC-'.,\!\+\(\)\/ ]+$/;
        $scope.addressChars = /^[A-z0-9-'.,\!\+\(\)\/\# ]+$/;
        $scope.onlyNumbers = /^([0-9]*)$/;
        $scope.validEmail = /^([\w-+\!\#\$\%\&]+(?:\.[\w-+\!\#\$\%\&]+)*)@((?:[A-z0-9-)]+\.)*\w[A-z0-9-]{0,66})\.([A-z0-9-]{2,8}(?:\.[A-z0-9-]{8})?)$/i;
        $scope.validEmailSpanish= /^([\w-+\u00E0-\u00FC\u00C0-\u00DC\!\#\$\%\&]+(?:\.[\w-+\u00E0-\u00FC\u00C0-\u00DC\!\#\$\%\&]+)*)@((?:[A-z0-9-)]+\.)*\w[A-z0-9-]{0,66})\.([A-z0-9-]{2,8}(?:\.[A-z0-9-]{8})?)$/i;     
        $scope.validAccount= /^[1]{1}[1-6|9]{1}[1]{1}[0-9]{10}$/;

        $window.setCapRequired = function (value) {
               $scope.caprequired=value;
               $scope.$digest();
            //   alert(value);
        };

      $scope.isCaliforniaAccount = function (value) {
            $scope.isOutSideOfCalifornia = false;
            if (value && (value.length > 3)) {
                var initialDigits = value.substring(0, 3);

                if ((initialDigits != "111") &&
                    (initialDigits != "121") &&
                    (initialDigits != "131") &&
                    (initialDigits != "141") &&
                    (initialDigits != "151") &&
                    (initialDigits != "161") &&
                    (initialDigits != "191")) {
                    //$scope.isOutSideOfCalifornia = true;
                }
            }

        };

        $scope.resetForm = function () {
            //alert($scope.resetForm);
            $scope.firstname = "";
            $scope.lastname = "";
            $scope.account = "";
            $scope.address = "";
            $scope.city = "";
            $scope.state = "";
            $scope.zipcode = "";
            $scope.phonenum = "";
            $scope.ownership = "";
            $scope.householdsize = "";
            $scope.annualincome = "";
            $scope.account = "";
            $scope.email = "";
            $('html,body').scrollTop(0);
        };
        $scope.resetForm();

        $scope.submit = function () {
            if ($scope.form_processed === "") {
                $scope.form_processed = "Processing . . .";
                var firstName = $scope.firstname,
                    lastName = $scope.lastname,
                    account = $scope.account,
                    address = $scope.address,
                    city = $scope.city,
                    state = $scope.state,
                    zip = $scope.zipcode,
                    phone = $scope.phonenum,
                    ownership = $scope.ownership,
                    householdsize = $scope.householdsize,
                    annualincome = $scope.annualincome, 
                    accountnumber = $scope.account,
                    email = $scope.email;
					
			if (!annualincome){
				annualincome = 'Blank';
			}
				
			if (!householdsize){
				householdsize = 'Blank';
			}

       $.ajax({
         url: "/swgasws/resources/form/esap/add",
         type: "post",
         dataType: 'json',
         contentType: "application/x-www-form-urlencoded;charset=utf-8",
         data: {
           firstName: firstName,
           lastName: lastName,
           address: address.replace(/#/g, ":"),
           city: city,
           state: state,
           zip: zip,
           phone: phone,
           ownership: ownership,
           householdsize: householdsize,
           annualincome: annualincome,
           account: accountnumber,
           email: email,
           language: "es",
           gRecaptchaResponse: grecaptcha.getResponse() 
         },
         success: function (data) {
           $scope.issuccessful = true;
           
           switch(data.status) {
           case 'success' :
          document.getElementById("responsemessage").innerHTML = "<p><br /><span class='form-sub-good'>" + data.message + "</span><span class='form-sub-normal'> Un contratista del programa ESA se pondrá en contacto con usted dentro de los próximos cinco días hábiles, con excepción de los feriados, para programar una cita y revisar sus calificaciones. Si tiene alguna pregunta, comuníquese con nosotros al </span><a href='tel:8778606020' style='color:#337ab7;'>877-860-6020</a>.</p>";
          break;
           case 'badrequest' :
          document.getElementById("responsemessage").innerHTML = "<p><br /><span class='form-sub-error'>" + data.message + " Intente de nuevo m&aacute;s tarde. Ya se ha notificado al Webmaster acerca de los siguientes problemas de env&iacute;o: <br /> " + data.sysmessage + "</span></p>";
          break;
           default:  // all other errors
          document.getElementById("responsemessage").innerHTML = "<p><br /><span class='form-sub-error'>" + data.message + " Ya se ha notificado al Webmaster acerca de este problema de env&iacute;o.</span></p>";    
               }  // end switch 
          $scope.isDisabled = !0;
          $scope.resetForm();
        },
        error: function (response) {
          document.getElementById("responsemessage").innerHTML = "<p><br /><span class='form-sub-error'>NO se ha enviado su consulta sobre el Programa de Asistencia para Ahorro de Energ&iacute;a debido a labores de mantenimiento. Le pedimos disculpas por los inconvenientes en este momento. Intente de nuevo m&aacute;s tarde.</span></p>";
          $scope.resetForm();
         }
                });
            }
        };

    });